import { ArrowRightOutlined, CarOutlined } from '@ant-design/icons';
import React from 'react';
import {
  daysBetween,
  expiryStatus,
  mockVehicles,
} from './mockData';
import styles from './styles.module.css';

type Props = {
  onClick: () => void;
};

const GarageHomeTile: React.FC<Props> = ({ onClick }) => {
  const vehicleCount = mockVehicles.length;
  const allExpiries = mockVehicles.flatMap((v) => [
    { name: 'Insurance', date: v.rc.insurance_data.expiry_date, plate: v.rc.document_id },
    { name: 'PUC', date: v.rc.pucc_data.expiry_date, plate: v.rc.document_id },
  ]);
  const nearest = allExpiries
    .map((e) => ({ ...e, days: daysBetween(e.date) }))
    .sort((a, b) => a.days - b.days)[0];
  const status = expiryStatus(nearest.days);

  return (
    <div className={styles.homeTile} onClick={onClick}>
      <div className={styles.homeTileLeft}>
        <div className={styles.homeTileBadge}>
          <CarOutlined />
        </div>
        <div>
          <div className={styles.homeTileTitle}>Garage</div>
          <div className={styles.homeTileSub}>
            {vehicleCount} vehicle{vehicleCount > 1 ? 's' : ''} ·{' '}
            {nearest.name} {nearest.days < 0 ? 'expired' : `in ${nearest.days}d`}
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {status.tone !== 'good' && (
          <span className={styles.homeTileAlert}>Action</span>
        )}
        <ArrowRightOutlined />
      </div>
    </div>
  );
};

export default GarageHomeTile;
